export default {"src":"/_next/static/media/carOutline25_40.464bd113.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};